// extracted by mini-css-extract-plugin
export default {"app":"Main_app__RqcN6"};